import cn from "classnames";
import {
  EmojiSuper,
  EmojiSuperDim,
  EmojiSad,
  EmojiSadDim,
  EmojiNormal,
  EmojiNormalDim,
  EmojiGood,
  EmojiGoodDim,
  EmojiAngry,
  EmojiAngryDim,
} from "./components";
import { EmojiProps } from "./types";
import styles from "./styles.scss";

export const Emoji = ({ index, hover, rating, active }: EmojiProps) => {
  const hasHover = hover !== -1;

  let viewType;

  if (hasHover) {
    if (index + 1 === (hover ?? rating)) {
      viewType = "action-positive";
    } else {
      viewType = "action-negative";
    }
  } else if (index + 1 === rating && rating !== -1) {
    viewType = "default-positive";
  } else {
    viewType = "default-negative";
  }

  if (rating === -1 && !hasHover) {
    viewType = "default";
  }

  if (index + 1 === active) {
    viewType = "click-positive";
  }

  const isNegativeVariant =
    viewType === "default-negative" ||
    viewType === "disabled" ||
    viewType === "action-negative";

  let content;

  switch (index) {
    case 0:
      content = isNegativeVariant ? <EmojiAngryDim /> : <EmojiAngry />;
      break;

    case 1:
      content = isNegativeVariant ? <EmojiSadDim /> : <EmojiSad />;
      break;

    case 2:
      content = isNegativeVariant ? <EmojiNormalDim /> : <EmojiNormal />;
      break;

    case 3:
      content = isNegativeVariant ? <EmojiGoodDim /> : <EmojiGood />;
      break;

    case 4:
      content = isNegativeVariant ? <EmojiSuperDim /> : <EmojiSuper />;
      break;

    default:
      content = <></>;
  }

  return (
    <div className={cn(styles.container, styles[viewType])}>{content}</div>
  );
};
